export enum RecipientTypeEnum {
    Invalid = 0,
    Email = 1,
    Voice = 2,
    //Fax = 3,  Fax notifications are no longer supported [das]
    Text = 4
}

